export const endpoint = {
  base: {
    enum: "/enum",
    city_state: "/state-cities",
    send_otp: "/otp",
    verify_otp: "/otp/verify",
    upload_file: "/upload-file",
  },
  institute: {
    enum: "/enum",
    verify_institute: "/verify",
    user_profile: "/user/profile",
    navigation_menu: "/navigation/menu",
    detail: "/detail",
  },
  account: {
    verify_user: "/auth/verify/user",
    login: "/auth/login",
    forgot_password: "/auth/forgot-password",
  },
  notification: {
    lists: "/lists",
  },
  admission: {
    enum: '/enum',
    lists: '/lists',
    documents: '/application/documents',
    activity: '/application/activity',
    enquiries: '/enquiries',
    fee_plans: '/fee-plans',
    qr_code: '/qr-code',
    direct_admission: '/direct/admission',
    application_fee: '/application/fee',
    admission_fee: '/admission/fee',
    approve: '/application/approve',
    admitted: '/application/admitted',
    reject: '/application/reject',
    document_status: '/application/document/status',
    send_reminder: '/document-upload/send-reminder',
  },
  payments: {
    info: '/info',
    lists: '/information/lists',
  },
  students: {
    enum: '/enum',
    lists: '/students/lists',
    detail: '/students',
    leave_lists: '/leave/lists',
    leave_status_update: '/leave/status/update',
    enrollment_lists: '/enrollment/lists',
    enrollment_create: '/enrollment/create',
    enrollment_status_update: '/enrollment/status/update',
    fee_plans: '/fee/plans',
    fee_installments: '/fee/installments',
    fee_installment_payment: '/fee/installment-payment',
    fee_payment_create: '/fee/payment/create',
    transport_fee_plans: '/transport-fee/plans',
    transport_fee_installments: '/transport-fee/installments',
    transport_fee_installment_payment: '/transport-fee/installment-payment',
    transport_fee_payment_create: '/transport-fee/payment/create',
    homeworks_list: '/homeworks/list',
    homeworks: '/homeworks',
    student_transfers: '/student-transfers',
    student_terminations: '/student-terminations',
    check_sin: '/check/sin_number',
    autocomplete: '/students/autocomplete',
  },
  attendances: {
    user_records: '/users/records',
    regularizations: '/users/attendance-regularizations',
  },
  hr_payroll: {
    enum: "/enum",
    employees: '/employees',
    departments: '/departments',
    designations: '/designations',
    grades: '/grades',
    employee_shifts: '/shifts',
    income_tax_configs: '/income-tax-configs',
    income_tax_slabs: '/income-tax-slabs',
    pay_heads: '/pay-heads',
    payroll_cycles: '/payroll-cycles',
    salary_structures: '/salary-structures',
    shift_off_rule: '/shift-off-rule',
    employee_salaries: '/employee-salaries',
    payslips: '/payslips',
    salary_settlements: '/salary-settlements',
    payroll_cycle_slabs: '/payroll-cycle-slabs',
    employee_leave_lists: '/leave/lists',
    employee_leave_balances: '/leave/balances',
    employee_reimbursements: '/reimbursements',
    employee_payroll_slabs: '/employee-payroll-slabs',
    kra_templates: '/kra-templates',
    appraisal_cycles: '/appraisal-cycles',
    appraisals: '/appraisals',
    employee_autocomplete: '/employees/autocomplete',
    employee_kras: '/employee-kras',
    leave_policies: '/leave/policies',
    leave_transactions: '/leave/transactions',
    resignations: '/resignation',
  },
  shifts: {
    list: '/institution/shifts',
  },
  shift_off_rules: {
    list: '/institution/shift-off-rule',
  },
  course_shifts: {
    list: '/institution/courses/shifts',
  },
  course_off_rules: {
    list: '/institution/course-off-rules',
  },
  curricular_activities: {
    list: '/institution/curricular-activities',
  },
  transportation: {
    enum: '/enum',
    vehicles: '/vehicles',
    vehicles_list: '/vehicles/list',
    gps_devices: '/gps-devices',
    drivers: '/drivers',
    drivers_list: '/drivers/list',
    routes: '/routes',
    vehicle_rto: '/vehicle-rto',
    vehicle_insurance: '/vehicle-insurance',
    vehicle_fitness: '/vehicle-fitness',
    vehicle_permit: '/vehicle-permit',
    fee_plans: '/fee-plans',
    fee_plan_item: '/fee-plans/fee-items',
    route_stops: '/route-stops',
    routes_list: '/routes/lists',
    route_stops_list: '/route-stops/lists',
    vehicle_driver_assignments: '/vehicle-driver-assignments',
    route_vehicles: '/route-vehicles',
    vehicle_gps_devices: '/vehicle-gps-devices',
    route_passengers: '/route-passengers',
    transport_applications: '/transport-applications',
    route_vehicle_live_location: '/route-vehicle-live-location',
    vehicle_helpers: '/vehicle-helpers',
    vehicle_helper_assignments: '/vehicle-helper-assignments',
  },
  institution: {
    faculty_list: "/institution/faculty-list",
    all_user_list: "/institution/all-user-list",
    announcements: "/institution/announcements",
    events: "/institution/events",
    events_awards_list: "/institution/events/awards/lists",
    events_published: "/institution/events/published",
    events_publish: "/institution/events",
    departments: "/institution/departments",
    designations: "/institution/designation",
    programs: "/institution/programs",
    coordinators: "/institution/programs/coordinators",
    courses: "/institution/courses",
    fee_heads: "/fee/heads",
    fee_plan: "/fee/plan",
    fee_plan_head: "/fee/plan/head",
    remove_fee_plan_item: "/fee/plan/head/item",
    fee_plan_programs: "/programs",
    timetable_courses: "/institution/timetable/courses",
    timetable_section: "/institution/timetable/section",
    timetable_generate: "/institution/timetable/generate",
    subjects: "/institution/subjects",
    subject_coordinators: "/institution/subjects/coordinators",
    sections: "/institution/courses/sections",
    sections_with_subjects: "/institution/courses/sections/subject",
    section_coordinators: "/institution/section/coordinators",
    available_rooms: "/institution/room/available",
    facility: "/institution/room-hall/facility",
    room: "/institution/room",
    hall: "/institution/hall",
    galleries: "/institution/galleries",
    galleries_published: "/institution/galleries/published",
    subject_chapters: "/institution/subject-chapters",
    institute_facilities: "/institution/institute-facilities",
    institute_facility_images: "/institution/institute-facility-images",
    document_check_lists: "/institution/document-check-lists",
  },
};
